module.exports = __webpack_public_path__ + "img/tower-isle.81c28ac1.jpg";